module.exports = __webpack_public_path__ + "img/arrow_down_circle.6e4bef81.svg";